<template>
  <div class="slider-container">
    <div @click="$emit('close')">
      <div class="btn-back-slider arrow-icon">
        {{ title }}
      </div>
    </div>
    <div v-if="searchbox" class="filter-box">
      <input
        type="text"
        spellcheck="false"
        :placeholder="$t('COMMON.str41')"
        v-model="filteredText"
      />
    </div>
    <div
      v-for="item in filteredList"
      :class="[
        'slider-item',
        {
          'selected-item': selected == item.value,
          clickable: !hasFooter,
        },
      ]"
      :key="item.value"
      @click="!hasFooter && $emit('callback', item.value)"
    >
      <div class="slider-item-content" v-html="getLocaleString(item.label)">
      </div>
      <div v-if="hasFooter && item.footer" class="slider-item-footer">
        {{ item.footer }}
      </div>
    </div>
    <div v-if="!filteredList.length">
      {{ $t('COMMON.str40') }}
    </div>
  </div>
</template>
<script>
import localeMixin from '@/mixins/localeMixin';
export default {
  name: 'MenuSlider',
  mixins: [localeMixin],
  props: {
    selected: {
      type: [Number, String, null],
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    searchbox: {
      type: Boolean,
    },
    hasFooter: {
      type: Boolean,
    },
    itemList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      filteredText: '',
    };
  },
  computed: {
    filteredList() {
      return this.filteredText
        ? this.itemList.filter(
            (el) =>
              el.label
                .toLowerCase()
                .indexOf(this.filteredText.toLowerCase()) !== -1
          )
        : this.itemList;
    },
  },
};
</script>
<style>
.filter-box > input[type='text'] {
  width: 100%;
}

.slider-container {
  width: 100%;
  height: 100%;
  position: absolute;
  border-radius: 10px;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: #fff;
  overflow: auto;
}

.btn-back-slider,
.slider-item.clickable {
  cursor: pointer;
}

.slider-item,
.btn-back-slider,
.filter-box {
  margin: 1em 2em 1em 3.2em;
  line-height: 1.6;
  text-align: left;
  word-break: keep-all;
}

.slider-item:not(.clickable) {
  word-break: break-word;
}

.slider-item:not(.clickable) a {
  color: #ff6000;
}

.btn-back-slider {
  position: relative;
}

.btn-back-slider {
  border-bottom: 1px solid #b5b5b5;
}

.slider-item.clickable:hover {
  background-color: #f2f2f2;
}

.selected-item {
  color: #e74a1e;
}

.btn-back-slider::after {
  left: -1.6em;
  top: 0.4em;
  transform: rotate(135deg);
}

.slider-item-footer {
  font-size: 0.85em;
  color: #898989;
}
</style>
